import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { LeftMenuComponent } from '../left-menu/left-menu.component';
import { CommonModule } from '@angular/common';
import { IconModule, LinkModule, PageTitleModule } from 'snl-complib';

@Component({
  selector: 'app-nav',
  standalone: true,
  imports: [LeftMenuComponent, PageTitleModule, CommonModule, RouterModule, IconModule, LinkModule],
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  header_title: string = '';
  backButtonNavigateTo: string = '';
  breadCrumbList: any = [];
  ownerName: any = '';
  navigationUrl: any = '';
  lastUpdateDate: any;

  constructor(
    private readonly router: Router,
    public navigationService: NavigationService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.router.events.subscribe((event) => {
      this.navigationService.setPageTitle('ST Contract Control Document - Dashboard');
      if (event instanceof NavigationEnd) {
        let routeUrl = event.urlAfterRedirects.split('/');
        this.navigationUrl = routeUrl[1];
      }

      //scroll to top after every route navigation
      this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
          return;
        }
        window.scrollTo(0, 0);
      });
    });
  }

  ngOnInit() {
    this.navigationService.getHeaderData().subscribe((data: any) => {
      this.header_title = data?.headerTitle;
      this.backButtonNavigateTo = data?.backButtonNavigateTo;
      this.breadCrumbList = data?.breadCrumbList;
      this.ownerName = this.fetchUserName(data?.ownerName);
      this.cdr.detectChanges();
    });
  }
  
	fetchUserName(name: string) {
		if (!name) {
			return '';
		}
		if (!name.includes('(')) {
			return name.trim();
		}
		return name.substring(0, name.indexOf('(')).trim();
	}

  navigateBack(navigateTo:string) {
    this.router.navigateByUrl(navigateTo);
  }

  selectedBreadcrumb(event:any){
    if(event?.navigateTo){
      this.router.navigateByUrl(event.navigateTo);
    }
  }

}
